import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendMutationUpdateProjectFolderArgs,
  BackendProjectFolder,
} from 'src/types/backend';

import { FRAGMENT_PROJECT_FOLDER } from './schema';

const MUTATION = gql`
  mutation UpdateProjectFolder($id: ID!, $name: String, $onSidebar: Boolean) {
    updateProjectFolder(id: $id, name: $name, onSidebar: $onSidebar) {
      ...ProjectFolder
    }
  }
  ${FRAGMENT_PROJECT_FOLDER}
`;

type Variables = BackendMutationUpdateProjectFolderArgs;
type Result = BackendProjectFolder;

export const updateProjectFolder = async (variables: Variables) => {
  const result = await executeGqlMutation({ mutation: MUTATION, variables });
  return getSingleProp<Result>(result.data);
};
